import { jsx as _jsx } from "react/jsx-runtime";
import { StarIcon } from "@heroicons/react/20/solid";
import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";
import clsx from "clsx";
import styles from "./StarRating.module.css";
const MAX_STARS = 5;
export const StarRating = ({ value, onChange, disabled = false, className, }) => {
    return (_jsx("div", { className: clsx(styles.container, className), children: Array.from({ length: MAX_STARS }, (_, i) => {
            const starValue = i + 1;
            const isActive = value !== null && starValue <= value;
            return (_jsx("button", { type: "button", className: clsx(styles.star, isActive && styles.active, disabled && styles.disabled), onClick: () => !disabled && onChange(starValue), "aria-label": `Rate ${starValue} star${starValue > 1 ? "s" : ""}`, "aria-pressed": isActive, children: isActive ? (_jsx(StarIcon, { "aria-hidden": true })) : (_jsx(StarIconOutline, { "aria-hidden": true })) }, starValue));
        }) }));
};
